module.exports = __webpack_public_path__ + "img/question-cross-open.f28dc411.svg";